import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { withAccount } from '../../components/AccountContext';
import SurveyProjectList from './SurveyProjectList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query surveyProjects(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: SurveyProjectFilter
    $sort: SurveyProjectSortSpecifier
  ) {
    account(id: $accountId) {
      id
      surveyProjects(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
        edges {
          cursor
          node {
            id
            name
            createdOn
            updatedOn
            createdBy {
              id
              firstName
              lastName
            }
            surveyTemplate {
              id
              title
            }
            numberOfSurveys
          }
        }
      }
    }
  }
`;

class SurveyProjectListContainer extends Component {
  render() {
    const { currentAccount, location } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);
    const variables = {
      ...pagination,
      accountId: currentAccount,
      sort: params.sort || { sortBy: 'updatedOn', sortDir: 'DESC' },
      filter: params.filter,
    };
    return (
      <Query query={LIST_QUERY} variables={variables} fetchPolicy="network-only">
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const connection = data && data.account ? data.account.surveyProjects : emptyConnection();

          return <SurveyProjectList connection={connection} currentAccount={currentAccount} loading={loading} />;
        }}
      </Query>
    );
  }
}

SurveyProjectListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withRouter(injectIntl(withAccount(SurveyProjectListContainer)));
